// React
import React from "react";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const LogProvider = ({ children }) => {
  // Framework
  const { log } = usePortal();
  // Init
  useStackDependency(log);
  // Render
  return <>{children}</>;
};

export { LogProvider };
